import { render, staticRenderFns } from "./InlineListBlock.vue?vue&type=template&id=0f4bee34&lang=pug"
import script from "./InlineListBlock.vue?vue&type=script&lang=js"
export * from "./InlineListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoverlyVendorItem: require('/app/components/pages/vendors/VendorItem.vue').default,LoverlyArticleItem: require('/app/components/pages/articles/ArticleItem.vue').default,LoverlyAuthorItem: require('/app/components/pages/authors/AuthorItem.vue').default,LoverlyDownloadItem: require('/app/components/elements/user/DownloadItem.vue').default,LoverlyShopProductItem: require('/app/components/pages/products/ShopProductItem.vue').default,LoverlyInspirationItem: require('/app/components/pages/wedding-inspiration/InspirationItem.vue').default,LoverlyRealWeddingItem: require('/app/components/pages/real-weddings/RealWeddingItem.vue').default,LoverlyVideoItem: require('/app/components/cards/VideoItem.vue').default,LoverlyImage: require('/app/components/elements/Image.vue').default,LoverlyListBlock: require('/app/components/blocks/ListBlock.vue').default})
